import { getTenantBasePath } from '@low6-pickem/frontend-shared';

type TokenGetter = () => Promise<string | null>;
type UnauthenticatedHandler = () => void;

let tokenGetter: TokenGetter | null = null;
let unauthenticatedHandler: UnauthenticatedHandler | null = null;
let isSignInRedirectPending = false;

export function setAuthTokenGetter(getter: TokenGetter): void {
  tokenGetter = getter;
}

export function setUnauthenticatedHandler(handler: UnauthenticatedHandler): void {
  unauthenticatedHandler = handler;
}

export async function getAuthToken(): Promise<string | null> {
  if (tokenGetter) {
    const token = await tokenGetter();
    if (token) {
      return token;
    }
  }
  return null;
}

export function isSignInRedirectActive(): boolean {
  return isSignInRedirectPending;
}

export function markSignInRedirectPending(): void {
  isSignInRedirectPending = true;
}

export function resetSignInRedirect(): void {
  isSignInRedirectPending = false;
}

export function handleUnauthenticated(): void {
  if (unauthenticatedHandler) {
    unauthenticatedHandler();
    return;
  }
  redirectToSignIn();
}

/**
 * Navigate to the app sign-in route.
 * Must use tenant base path (or root), NOT the current page path —
 * otherwise /main/lobby becomes /main/lobby/sign-in.
 */
export function redirectToSignIn(): void {
  const basePath = getTenantBasePath();
  const signInPath = `${basePath}/sign-in`.replace(/\/{2,}/g, '/');
  if (!window.location.pathname.includes('/sign-in')) {
    window.location.href = signInPath;
  }
}
